import React from 'react';
import { Link } from 'react-router-dom'; 
const FooterLogo = '/footer_logo.png';

const Footer = () => { 
  const currentYear = new Date().getFullYear();

  return ( 
     <footer className="footer-section">
      <div className="landing-footer">
          <div className="footer-container">
            <div className="footer-content">
              <div className="footer-brand">
                <Link to="/landing" onClick={() => window.scrollTo({
                  top: 0,
                  behavior: 'smooth'
                })}>
                  <img src={FooterLogo} alt="Nivaas" className="footer-logo" />
                </Link>
                <p className="footer-description">
                  The complete society management platform trusted by residential communities nationwide.
                </p>
              </div>
              <div className="footer-links">
                <div className="footer-column">
                  <h4>Product</h4>
                  <a href="#features">Features</a>
                  <a href="#pricing">Pricing</a>
                  <a href="/register">Sign Up</a>
                  <a href="/login">Sign In</a>
                </div>
                <div className="footer-column">
                  <h4>Support</h4>
                  <a href="/contact">Contact Us</a>
                  <a href="/support">Help Center</a>
                  <a href="/privacy">Privacy Policy</a>
                  <a href="mailto:support@nivaas.app">Email Support</a>
                </div>
              </div>
            </div>
          </div>
          </div>

        {/* Copyright Section */}
        <section className="copyright-section">
          <div className="copyright-container">
            <p>&copy; {currentYear} Nivaas by Kudosta Solutions LLP. All rights reserved.</p>
          </div>
        </section>
   </footer>
  );
};

export default Footer; 